
















import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class ConsentCheck extends Vue {
    @Prop() value!: boolean;

    checkboxToggled() {
        this.$emit('input', !this.value);
    }
}
